import { Megaphone, AlertTriangle, Siren, PartyPopper } from 'lucide-react';

// Visual identity for each announcement level. Class strings are written out
// in full so Tailwind's content scan picks them up.
export const LEVELS = {
  update: {
    label: 'Update',
    Icon: Megaphone,
    banner: 'from-blue-600/40 via-indigo-600/30 to-blue-600/40 border-blue-400/40 text-blue-50',
    iconWrap: 'bg-blue-500 text-white',
    ping: 'bg-blue-400',
    chip: 'bg-blue-500/20 text-blue-200 border-blue-400/40',
    hero: 'from-blue-600 via-indigo-600 to-blue-700',
    bar: 'bg-blue-400',
    dot: 'bg-blue-400',
  },
  warning: {
    label: 'Warning',
    Icon: AlertTriangle,
    banner: 'from-amber-500/40 via-orange-500/30 to-amber-500/40 border-amber-400/50 text-amber-50',
    iconWrap: 'bg-amber-500 text-slate-900',
    ping: 'bg-amber-400',
    chip: 'bg-amber-500/20 text-amber-200 border-amber-400/40',
    hero: 'from-amber-500 via-orange-500 to-amber-600',
    bar: 'bg-amber-400',
    dot: 'bg-amber-400',
  },
  urgent: {
    label: 'Urgent',
    Icon: Siren,
    banner: 'from-red-600/60 via-rose-600/50 to-red-600/60 border-red-400/60 text-white ksp-ann-urgent-glow',
    iconWrap: 'bg-red-500 text-white ksp-ann-wiggle',
    ping: 'bg-red-400',
    chip: 'bg-red-500/20 text-red-200 border-red-400/40',
    hero: 'from-red-600 via-rose-600 to-red-700',
    bar: 'bg-red-400',
    dot: 'bg-red-400',
  },
  celebration: {
    label: 'Celebration',
    Icon: PartyPopper,
    banner: 'from-fuchsia-600/50 via-violet-600/40 to-pink-600/50 border-fuchsia-400/50 text-white ksp-ann-gradient-flow',
    iconWrap: 'bg-fuchsia-500 text-white ksp-ann-bounce',
    ping: 'bg-fuchsia-400',
    chip: 'bg-fuchsia-500/20 text-fuchsia-200 border-fuchsia-400/40',
    hero: 'from-fuchsia-600 via-violet-600 to-pink-600',
    bar: 'bg-fuchsia-400',
    dot: 'bg-fuchsia-400',
  },
};

export const levelOf = (level) => LEVELS[level] || LEVELS.update;

export const formatDateTime = (value) => {
  if (!value) return '';
  return new Date(value).toLocaleString(undefined, {
    month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit',
  });
};

export const formatRelative = (value) => {
  if (!value) return '';
  const diffMs = Date.now() - new Date(value).getTime();
  const mins = Math.round(diffMs / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  if (days < 7) return `${days}d ago`;
  return new Date(value).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
};
